<template>
  <div class="row" v-loading="true" id="loading">
  </div>
</template>
<script>
import Vue from 'vue';
import { Loading } from 'element-ui';

Vue.use(Loading.directive);
export default {};
</script>
<style lang="scss">
#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
}

.el-loading-spinner .path {
  stroke: #273c75 !important;
}

// .el-loading-mask {
//   background: transparent !important;
// }

.el-loading-spinner .el-loading-text{
  font-weight: bold;
  color: #273c75;
}
</style>
